import superagentInterfaceImport from 'redux-query-interface-superagent';

/**
 * Legacy CJS package: under Rolldown the default import resolves to
 * `{ default: { default: fn } }` (its `module` field points at a non-ESM build),
 * so unwrap nested `default` chains. `T` is inferred from the typed import to
 * preserve the declared `NetworkInterface` signature.
 */
function resolveLegacyDefaultExport<T>(mod: T): T {
  let current: unknown = mod;
  for (let depth = 0; depth < 3; depth++) {
    if (typeof current === 'function') {
      return current as T;
    }
    if (current && typeof current === 'object' && 'default' in current) {
      current = (current as { default: unknown }).default;
      continue;
    }
    break;
  }
  throw new Error('redux-query-interface-superagent did not resolve to a function');
}

const superagentInterface = resolveLegacyDefaultExport(superagentInterfaceImport);

/**
 * Custom network adapter that wraps superagent interface
 * to ensure response headers are accessible in transform functions
 */
const customSuperagentInterface = (
  url: string,
  method: string,
  config: any
) => {
  const networkInterface = superagentInterface(url, method, config);

  return {
    abort: networkInterface.abort,
    execute: (
      callback: (
        err: any,
        status: number,
        body: any,
        text: any,
        headers: any
      ) => void
    ) => {
      networkInterface.execute((err, status, body, text, headers) => {
        let modifiedBody = body;

        // Attach headers to the response body ONLY for object responses
        // to ensure backward compatibility with arrays and primitives
        // This wil be redisigned when upgrading infrastructure of the app
        if (
          headers &&
          body &&
          typeof body === 'object' &&
          !Array.isArray(body)
        ) {
          modifiedBody = {
            ...body,
            headers,
          };
        }

        callback(err, status, modifiedBody, text || '', headers);
      });
    },
  };
};

export default customSuperagentInterface;
